<template>
  <div>
    <button @click="createCategory" type="button" class="btn-basic mt-4 float-right">
      Add Category
    </button>
    <br />
    <br />
    <br />
    <br />
    <div class="card card-body p-0" style="border-radius: 10px">
      <div class="table-responsive">
        <table class="table table-hover border-bottom" id="dataTable" width="100%" cellspacing="0">
          <thead>
            <tr>
              <th>Title</th>
              <th>Description</th>
              <!-- <th>Moderator</th> -->
              <th>FAQs</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <!-- link moderator -->
            <tr  v-if="displayLoader" id="table_row" >
              <td colspan="16">
                <b-skeleton-wrapper >
                    <b-skeleton height="40px" ></b-skeleton>   
                    <b-skeleton height="40px"></b-skeleton>  
                    <b-skeleton height="40px"></b-skeleton>                                     
                </b-skeleton-wrapper> 
              </td>
            </tr>
            <category-row v-show="!displayLoader" v-for="FAQcategory in FAQcategories" :FAQcategory="FAQcategory" :key="FAQcategory.id">
            </category-row>
          </tbody>
        </table>

        <h5 style="text-align: center; margin-top:2rem;" v-if="FAQcategories.length < 1 && !displayLoader">
          No Record found.
        </h5>

        <paginate v-if="!displayLoader" v-model="page" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
          :first-button-text="''" :last-button-text="''" :first-last-button="true"
          :container-class="'pagination pagination-sm float-right mb-0 mt-3 mr-4'" :page-class="'page-item'"
          :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
          :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
      </div>
    </div>
  </div>
</template>

<script>
  // import Loading from 'vue-loading-overlay';
  import helpers from "@/helpers.js";
  import categoryForm from "./form";
  import CategoryRow from "./category_row";
  import VueSkeletonLoader from 'skeleton-loader-vue';
  export default {
    components: {
      CategoryRow,VueSkeletonLoader
    },
    data: function () {
      return {
        page: 0,
        fullPage: "",
        displayLoader: true,
      };
    },
    computed: {
      FAQcategories: function () {
        return this.$store.getters["faqcategories/FAQcategories"];
      },
      totalPages: function () {
        return this.$store.getters["faqcategories/totalPages"];
      },
    },
    created: function () {
      this.page = helpers.getPageQuery();
      this.getAllCategories();
    },
    watch: {
      page: function (val) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.page = val;
        this.getAllCategories();
      },
    },
    methods: {
      setPage(page) {
        this.page = page;
        this.$router.push("faqcategories?page=" + page);
      },
      createCategory() {
        this.$store.dispatch("modal/update", {
          action: "create",
          title: "Add Category",
          component: categoryForm,
        });
      },
      setSkeletonLoader(val){
        this.displayLoader = val;
      },

      getAllCategories(){
        this.setSkeletonLoader(true);
        this.$store.dispatch("faqcategories/getAllFAQCategories", this.page);
        setTimeout(() => {
          this.setSkeletonLoader(false);
        }, 2000);
      }
    },
  };
</script>
<style>
  .custom {
    position: absolute;
    z-index: 999;
    top: 246px;
    left: 40%;
    opacity: 0.5;
  }
  thead th{
    text-align: left;
  }

  /* tbody td:nth-child(1){
  width: 30%;
}
tbody td:nth-child(2){
  width: 40%;
}
tbody td:nth-child(3){
  width: 15%;
}
tbody td:nth-child(4){
  width: 15%;
} */
</style>